import { ExchangeDto } from './exchange.dto';

export class Exchange {
    rate: number;

    constructor(data: ExchangeDto) {
        this.rate = data.exchangeRate === null ? 1 : data.exchangeRate;
    }
}
